import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    viewBox="0 0 64 64"
    ref={svgRef}
    {...props}
  >
    <mask
      id="help_svg__a"
      style={{
        maskType: "alpha",
      }}
      width={64}
      height={64}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
    >
      <path fill="currentColor" d="M0 0h64v64H0z" />
    </mask>
    <g mask="url(#help_svg__a)">
      <path
        fill="currentColor"
        d="M31.867 48c.933 0 1.722-.322 2.366-.967.645-.644.967-1.433.967-2.366 0-.934-.322-1.723-.967-2.367-.644-.644-1.433-.967-2.366-.967-.934 0-1.723.323-2.367.967-.645.644-.967 1.433-.967 2.367 0 .933.322 1.722.967 2.366.644.645 1.433.967 2.367.967zM32 58.667c-3.689 0-7.156-.7-10.4-2.1-3.245-1.4-6.067-3.3-8.467-5.7-2.4-2.4-4.3-5.223-5.7-8.467-1.4-3.244-2.1-6.711-2.1-10.4s.7-7.156 2.1-10.4c1.4-3.245 3.3-6.067 5.7-8.467 2.4-2.4 5.223-4.3 8.467-5.7 3.244-1.4 6.711-2.1 10.4-2.1s7.156.7 10.4 2.1c3.244 1.4 6.067 3.3 8.467 5.7 2.4 2.4 4.3 5.223 5.7 8.467 1.4 3.244 2.1 6.711 2.1 10.4s-.7 7.156-2.1 10.4c-1.4 3.244-3.3 6.067-5.7 8.467-2.4 2.4-5.223 4.3-8.467 5.7-3.244 1.4-6.711 2.1-10.4 2.1zm.267-38.134c1.11 0 2.077.356 2.9 1.067.822.711 1.233 1.6 1.233 2.667 0 .977-.3 1.844-.9 2.6-.6.755-1.278 1.466-2.033 2.133a17.702 17.702 0 00-2.7 2.933 5.961 5.961 0 00-1.167 3.6c0 .623.233 1.145.7 1.567a2.358 2.358 0 001.633.633c.667 0 1.234-.222 1.7-.666.467-.445.767-1 .9-1.667a5.352 5.352 0 011.2-2.5 25.403 25.403 0 012-2.1 17.1 17.1 0 002.634-3.2c.733-1.156 1.1-2.445 1.1-3.867 0-2.266-.923-4.122-2.767-5.566C36.855 16.722 34.711 16 32.267 16c-1.69 0-3.3.355-4.834 1.067-1.533.71-2.7 1.8-3.5 3.266a2.404 2.404 0 00-.3 1.7c.111.6.411 1.056.9 1.367.622.356 1.267.467 1.934.333.666-.133 1.222-.51 1.666-1.133a4.89 4.89 0 011.834-1.533 5.21 5.21 0 012.3-.534z"
      />
    </g>
  </Icon>
));
